import React from "react";
import isotipoHabitia from "../../../assets/isotipo.png";

// PAGINA 11 — Capitulo XV (Piscina, hidromasaje y sauna, condicional).
export default function PiscinaPage({ config, pagNum, pagTotal, capRomanoMap }) {
  const secNum = String(pagNum - 2).padStart(2, "0");
  return (
    <section className="page">
      <div className="page-pad">
        <span className="sec-tag">{secNum} · Amenities (3)</span>
        <h2 className="big">Piscina, hidromasaje <em>y sauna.</em></h2>

        <div className="art">
          <div className="art-head">
            <div className="art-num">Capítulo {capRomanoMap.piscina}</div>
            <h3 className="art-title">Piscina, hidromasaje y sauna</h3>
          </div>
          <div className="hours-grid">
            {config.horarios.piscina.map((h) => (
              <div key={h.id} className="hours-card">
                <div className="lbl">{h.lbl}</div>
                <div className="val">{h.val}</div>
                {h.note && <div className="note">{h.note}</div>}
              </div>
            ))}
          </div>
          <h4 className="sub-h">Piscina</h4>
          <ol className="rules">
            <li><span className="m">a</span><span>Sin guardavidas. Uso por <b>exclusiva responsabilidad</b> del usuario.</span></li>
            <li><span className="m">b</span><span>Menores de 12 años siempre acompañados por un adulto.</span></li>
            <li><span className="m">c</span><span>Traje de baño o indumentaria apropiada; salida de duchas.</span></li>
            <li><span className="m">d</span><span>Baño completo con jabón antes de entrar al agua.</span></li>
            <li><span className="m">e</span><span>Prohibidos: cremas bronceadoras, alimentos, alcohol.</span></li>
            <li><span className="m">f</span><span>No correr; ingreso solo por escalera; sin saltos ni juegos bruscos.</span></li>
            <li><span className="m">g</span><span>Prohibidos cristales, objetos cortantes, equipos de sonido sin auriculares.</span></li>
            <li><span className="m">h</span><span>No se permite uso a personas con heridas o infecciones.</span></li>
            <li><span className="m">i</span><span>Prohibido salir mojado hacia cualquier área del edificio.</span></li>
          </ol>
          <h4 className="sub-h">Hidromasaje</h4>
          <ol className="rules">
            <li><span className="m">a</span><span>Preparación de 2-3 horas; coordinar uso con personal.</span></li>
            <li><span className="m">b</span><span>Aplican todos los puntos del uso de la piscina.</span></li>
          </ol>
          <h4 className="sub-h">Sauna</h4>
          <ol className="rules">
            <li><span className="m">a</span><span>Uso bajo exclusiva responsabilidad.</span></li>
            <li><span className="m">b</span><span><b>No se permite a menores de 18 años.</b></span></li>
            <li><span className="m">c</span><span>Avisar a portería antes y después del uso.</span></li>
            <li><span className="m">d</span><span>Ducharse con jabón antes de pasar a la piscina.</span></li>
          </ol>
        </div>
      </div>
      <div className="pfooter">
        <div className="br"><img src={isotipoHabitia} alt="" />habitia · Reglamento Interno</div>
        <div className="pn">{String(pagNum).padStart(2, "0")} / {String(pagTotal).padStart(2, "0")}</div>
      </div>
    </section>
  );
}
